import { h, render } from 'preact'
import Glide from '@glidejs/glide'
import { Carrousel } from '../../components/carrousel/carrousel.jsx'
import { SG1Logs } from '../modules/logs.js'

export const carrouselOrchestrator = (data) => {
   try {
      if (data.zones[0].data.slides.length === 0) throw ('Pas de bannieres dans les données')
      let format = getFormat(dataStoreHP.pageId, dataStoreHP.device)
      render(<Carrousel slides={data.zones[0].data.slides} format={format} />, document.getElementById('carrousel'))
   } catch (error) {
      console.error('Carrousel orchestrator', error)
      SG1Logs.incLog('Err_CORCH')
      SG1Logs.sentryEvent({ error: error, data: value, name: 'Carrousel Orchestrator' })
   }
}

const getFormat = (pageId, deviceType) => {
   let format = ''
   switch (pageId) {
      case 'hp-regulier':
         format = 'regulier'
         break
      case 'hp-occasionnel':
         format = 'occasionnel'
         break
      case 'hp-prospect':
         format = 'prospect'
         break
      case 'vitrine-boutique':
      case 'vitrine-boutique-client':
         format = 'boutique'
         break
      case 'n1-forfaits-prospect':
      case 'n1-forfaits':
         format = 'mobile'
         break
      case 'n1-tv-prospect':
      case 'n1-tv':
         format = 'tv'
         break
   }
   return deviceType === 'mobile' ? `${format}-mobile` : format
}

export const glideInit = (nbSlide) => {
   const autoplaySeconds = 5000
   var autoplayValue = autoplaySeconds
   var dragThresholdValue = true
   var swipeThresholdValue = true

   if (nbSlide === 1) {
      autoplayValue = false
      dragThresholdValue = false
      swipeThresholdValue = false
   }

   let glideOption = {
      type: 'carousel',
      gap: 0,
      autoplay: autoplayValue,
      hoverpause: false, // géré de notre côté
      dragThreshold: dragThresholdValue,
      swipeThreshold: swipeThresholdValue,
   }

   let glideCarrousel = new Glide('.glide-carousel', glideOption)
   glideCarrousel.mount()


   // MENTIONS LEGALES
   // Referme les mentions legals si le slide n'est plus actif
   const observer = new MutationObserver((mutationList, observer) => {
      mutationList.forEach((mutation) => {
         if (mutation.target.classList.value === 'glide__slide glide__slide--active') {
            document.querySelectorAll('.glide-carousel .glide__slide:not(.glide__slide--active) .openContent').forEach((el) => {
               el.classList.remove('openContent')
            })
         }
      })
   })
   const parentNode = document.querySelector('.glide-carousel .glide__slides')
   observer.observe(parentNode, { attributes: true, childList: false, subtree: true })


   // NAVIGATION FLECHES
   // ajout d'evenements pour la navigation flèche
   // fix bug double event sur touch device : https://github.com/glidejs/glide/issues/417
   const glideArrows = document.querySelectorAll('.glide-carousel .glide__arrow')
   glideArrows.forEach(function (glideArrow) {
      glideArrow.addEventListener('click', function () {
         glideCarrousel.go(glideArrow.dataset.glideDir)
      })
   })


   // BOUTON PAUSE
   var glideForcePause = false
   
   document.querySelectorAll('.glide__playpause').forEach((el) => {
      const ariaLabelPlay = 'Reprendre la lecture du carrousel'
      const ariaLabelPause = 'Mettre en pause le carrousel'
      
      // init
      if (glideForcePause) {
         el.classList.remove('glide__playpause--pause')
         el.classList.add('glide__playpause--play')
         el.setAttribute('aria-label', ariaLabelPlay)
      }
      // click event
      el.addEventListener('click', (e) => {
         if (!glideForcePause) {
            glideCarrousel.update({ autoplay: false })
            autoplayValue = false
            tabEventsInit()
            pauseOnHoverInit()
            el.classList.remove('glide__playpause--pause')
            el.classList.add('glide__playpause--play')
            el.setAttribute('aria-label', ariaLabelPlay)
            glideForcePause = true
         } else {
            glideCarrousel.update({ autoplay: autoplayValue })
            autoplayValue = autoplaySeconds
            tabEventsInit()
            pauseOnHoverInit()
            el.classList.remove('glide__playpause--play')
            el.classList.add('glide__playpause--pause')
            el.setAttribute('aria-label', ariaLabelPause)
            glideForcePause = false
         }
      })

      el.addEventListener('mousedown', (e) => {
         e.preventDefault()
      })
   })


   // INTERACTIONS SOURIS
   // remove focus au clic souris
   document.querySelectorAll('a.o-carousel-item').forEach((el) => {
      el.addEventListener('mousedown', (event) => {
         event.preventDefault()
      })
   })
   // pause au survol
   function pauseOnHoverInit() {
      document.querySelectorAll('.glide-carousel').forEach((el) => {
         el.addEventListener('mouseenter', (e) => {
            glideCarrousel.update({ autoplay: false })
         })

         el.addEventListener('mouseleave', (e) => {
            if (!glideForcePause) {
               glideCarrousel.update({ autoplay: autoplayValue })
            }
         })
      })
   }
   pauseOnHoverInit()


   // NAVIGATION CLAVIER
   // ignore clones (<a> de la slide + <button> des conditions legales)
   function removeTabIndexFromClones() {
      document.querySelectorAll('.glide-carousel .glide__slide--clone a').forEach((el) => {
         el.setAttribute('tabindex', '-1')
      })
      document.querySelectorAll('.glide-carousel .glide__slide--clone .showButton').forEach((el) => {
         el.setAttribute('tabindex', '-1')
      })
   }
   removeTabIndexFromClones()

   document.querySelectorAll('.glide-carousel').forEach((el) => {
      el.addEventListener('focusin', (e) => {
         removeTabIndexFromClones()
      })
      el.addEventListener('focusout', (e) => {
         removeTabIndexFromClones()
      })
   })

   function setTabEventsInitListeners(el) {
      let currentSlide = el.closest('[data-slidenb]').dataset.slidenb
      let showButtonIsHover = false

      el.addEventListener("mouseover", (e) => {
         showButtonIsHover = true
      })

      el.addEventListener('focus', (e) => {
         if (!showButtonIsHover) { // evite le déclencherment au focus souris
            // stop autoplay
            glideCarrousel.update({ autoplay: false })
            // prevent default tab scroll
            el.closest('.glide__track').scrollLeft = 0
            // go to focused slide
            glideCarrousel.go('=' + currentSlide)
         }
      })

      el.addEventListener('blur', () => {
         if (!el.dataset.glidePaused && !glideForcePause) {
            // start autoplay
            glideCarrousel.update({ autoplay: autoplayValue })
         }
      })
   }
   // init nav clavier
   function tabEventsInit() {
      document.querySelectorAll('.glide-carousel .glide__slide:not(.glide__slide--clone) a').forEach((el) => {
         setTabEventsInitListeners(el)
      })
      document.querySelectorAll('.glide-carousel .glide__slide:not(.glide__slide--clone) .showButton').forEach((el) => {
         setTabEventsInitListeners(el)
      })
   }

   tabEventsInit()
}
